import { AssistantSuggestion } from "@/types/assistant-suggestion"

/**
 * Server-pushed suggestion-stream events (BroadcastService
 * MESSAGE_ASSISTANT_SUGGESTIONS): one "card" per suggestion as it publishes
 * mid-generation, then a final "complete".
 */
export type AssistantSuggestionsEvent =
  | { event: "card"; suggestion: AssistantSuggestion }
  | { event: "complete" }

type Listener = (event: AssistantSuggestionsEvent) => void

const listeners = new Set<Listener>()

export function dispatchAssistantSuggestionsEvent(
  event: AssistantSuggestionsEvent
) {
  listeners.forEach((listener) => listener(event))
}

/** Subscribe; returns the unsubscribe function. */
export function onAssistantSuggestionsEvent(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
